<template>
  <div
    class="presidential-elections-second-round"
    :class="{ container: !isElectionTag }"
    v-if="presidentialElectionsSecondRoundData.lastBulletin"
  >
    <h3 class="heading-title">
      Elecciones Presidenciales 2026 - Segunda Vuelta
    </h3>
    <div class="first-col">
      <template
        v-for="item in presidentialElectionsSecondRoundData.lastBulletin.candidates.slice(
          0,
          2,
        )"
      >
        <div class="card-election-1">
          <img
            :alt="item.name"
            :title="item.name"
            :src="`${item.image}?w=320`"
            :height="210"
            :width="210"
          />
          <div class="info-candidate">
            <div class="candidate-name" v-html="item.name"></div>
            <div class="votes">Votos {{ format(item.votes) }}</div>
            <div class="bar">
              <div
                class="r"
                :style="{
                  width: item.percentage * 100 + '%',
                  backgroundColor: item.color,
                }"
              ></div>
            </div>
            <div
              class="percentage"
              :style="{ color: item.color }"
              v-html="formatPercent(item.percentage)"
            ></div>
          </div>
        </div>
      </template>
    </div>
    <div>
      <PresidentialElections2026Colgraph></PresidentialElections2026Colgraph>
    </div>
    <div class="third-col bulletin-info-cards">
      <div class="wrap-bulletin">
        <div class="bulletin">
          AVANCE
          <span
            class="number-bulletin"
            v-html="
              presidentialElectionsSecondRoundData.lastBulletin.bulletin
                .bulletinNumber
            "
          ></span>
        </div>
        <span v-html="currentTime" class="current-time"></span>
      </div>
      <div class="card-info c-1">
        <div class="row-1">
          <div class="percentage">
            {{
              formatPercent(
                presidentialElectionsSecondRoundData.lastBulletin.bulletin
                  .percentageInformedTables,
              )
            }}
          </div>
          <div class="informed-tables">Mesas Informadas</div>
        </div>
        <div class="row-2">
          {{
            format(
              presidentialElectionsSecondRoundData.lastBulletin.bulletin
                .informedTables,
            )
          }}
          de
          {{
            format(
              presidentialElectionsSecondRoundData.lastBulletin.bulletin
                .totalTables,
            )
          }}
          mesas informadas
        </div>
      </div>
      <div class="card-info c-2">
        <div class="row-1">
          <div class="percentage">
            {{
              formatPercent(
                presidentialElectionsSecondRoundData.lastBulletin.bulletin
                  .percentageTotalVotes,
              )
            }}
          </div>
          <div class="vote">Votación</div>
        </div>
        <div class="row-2">
          {{
            format(
              presidentialElectionsSecondRoundData.lastBulletin.bulletin
                .totalVotes,
            )
          }}
          de
          {{
            format(
              presidentialElectionsSecondRoundData.lastBulletin.bulletin
                .potentialVotes,
            )
          }}
          personas habilitadas
        </div>
      </div>
      <div class="card-info">
        <div class="row-1">
          <div class="percentage">
            {{
              formatPercent(
                presidentialElectionsSecondRoundData.lastBulletin.bulletin
                  .percentageBlankVotes,
              )
            }}
          </div>
          <div class="vote">En Blanco</div>
        </div>
        <div class="row-2">
          {{
            format(
              presidentialElectionsSecondRoundData.lastBulletin.bulletin
                .blankVotes,
            )
          }}
          votos
        </div>
      </div>
      <div class="card-info">
        <div class="row-1">
          <div class="percentage">
            {{
              formatPercent(
                presidentialElectionsSecondRoundData.lastBulletin.bulletin
                  .percentageNullVotes,
              )
            }}
          </div>
          <div class="vote">Nulos</div>
        </div>

        <div class="row-2">
          {{
            format(
              presidentialElectionsSecondRoundData.lastBulletin.bulletin
                .nullVotes,
            )
          }}
          votos
        </div>
      </div>
    </div>
    <div class="button" v-if="presidentialElectionsUrl">
      <a :href="presidentialElectionsUrl" class="btn">RESULTADOS COMPLETOS</a>
    </div>
  </div>
</template>
<script>
import PresidentialElections2026Colgraph from "../presidential-elec2026-colgraph/PresidentialElec2026ColGraph.vue";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { useLRWebSocketV2 } from "../../../features/lr-websocket-v2.js";

export default {
  components: {
    PresidentialElections2026Colgraph,
  },
  props: {
    presidentialElectionsUrl: {
      type: String,
      required: false,
    },
    isElectionTag: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  created() {
    this.$store.dispatch("elections/getPres2026_2_Home");
    useLRWebSocketV2(this.$store);
  },
  computed: {
    presidentialElectionsSecondRoundData() {
      return this.$store.getters["elections/pres2026_2_home"];
    },

    currentTime() {
      if (!this.presidentialElectionsSecondRoundData.lastBulletin) return "";

      return dayjs(
        this.presidentialElectionsSecondRoundData.lastBulletin.bulletin.date,
      )
        .locale("es")
        .format("hh:mm a");
    },
  },

  methods: {
    formatPercent(value) {
      if (value === null || value === undefined) return "";

      return value.toLocaleString("es-CO", {
        style: "percent",
        maximumFractionDigits: 2,
      });
    },
    format(value) {
      if (value === null || value === undefined) return "";

      return value.toLocaleString("es-CO");
    },
  },
};
</script>
